<template>
  <v-card
    flat
    :to="to"
    class="articles-card d-flex align-center rounded-0 my-4 pr-4"
  >
    <img class="d-block" :src="img + '?resize=1&w=400'" />
    <div class="d-flex flex-column ml-4">
      <div class="articles-card-title grey--text text-body-1 text-md-h6">
        <span class="font-barlow">{{ title }}</span>
      </div>
      <div
        class="
          mt-5
          d-flex
          align-baseline
          articles-card-date
          grey--text
          text--lighten-3
        "
      >
        <v-icon size="16" color="grey lighten-3">far fa-calendar</v-icon>
        <span class="text-caption text-uppercase ml-2">
          {{ date }}
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.articles-card:first-child {
  margin-top: 0 !important;
}
.articles-card:last-child {
  margin-bottom: 0 !important;
}
.articles-card {
  &:hover .articles-card-title {
    color: var(--v-secondary-base) !important;
  }
  img {
    object-fit: cover;
    aspect-ratio: 161 / 115;
    height: 115px;
    border-radius: 8px !important;
  }
  &-title {
    line-height: 100% !important;
    transition: all 0.2s ease;
  }
}
</style>
